import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import {BASE_URL} from "../../utility/path";
import { updateDetailsAction } from "./detailsSlice";
import { spinner } from "./spinnerSlice";
import { getConfig, handleErrorResponse } from "../../services/functions";

// action list
export const listRatingAction = createAsyncThunk(
    "rating/list",
    async (user, { rejectWithValue, getState, dispatch }) => {
      
      const config = getConfig();

      try {
        const { data } = await axios.get(
          `${BASE_URL}/api/ratings/list`,
          user,
          config
        );
  
        return data;
  
      } catch (error) {
        console.log(error);
        const errorResponse = handleErrorResponse(error, dispatch);
        return rejectWithValue(errorResponse);
      }

    }
);

// action add
export const addRatingAction = createAsyncThunk(
  "ratings/add",
  async (user, { rejectWithValue, getState, dispatch }) => {
    dispatch(spinner(true));
    
    const config = getConfig();
    
    try {
      const { data } = await axios.post(
        `${BASE_URL}/api/ratings/add`,
        user,
        config
      );

      //let list = Object.assign([], getState()?.posts?.data);
      //list.push(data);
      dispatch(updateDetailsAction(data));
      return data;

    } catch (error) {
      dispatch(spinner(false));
      console.log(error);
      const errorResponse = handleErrorResponse(error, dispatch);
        return rejectWithValue(errorResponse);
    }

  }
);

  
//slices
const ratingsSlices = createSlice({
  name: "ratings",
  initialState: {
    data: [],
  },
  extraReducers: builder => {
    //list
    builder.addCase(listRatingAction.pending, (state, action) => {
      state.loading = true;
      state.appErr = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(listRatingAction.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action?.payload;
      state.appErr = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(listRatingAction.rejected, (state, action) => {
      state.loading = false;
      state.appErr = action?.payload?.message;
      state.serverErr = action?.error?.message;
    });


    //add
    builder.addCase(addRatingAction.pending, (state, action) => {
      state.loading = true;
      state.appErr = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(addRatingAction.fulfilled, (state, action) => {
      //console.log('action?.payload',action?.payload, state)
      state.loading = false;
      state.data.push[ action?.payload];
      state.appErr = undefined;
      state.serverErr = undefined;
    });
    builder.addCase(addRatingAction.rejected, (state, action) => {
      state.loading = false;
      state.appErr = action?.payload?.message;
      state.serverErr = action?.error?.message;
    });
  },
});
  
export default ratingsSlices.reducer;
 
